// src/lib/robots.js
// Units: speed mm/s, accel mm/s^2, payload kg

// ----- Local fallback (works offline) -----
const LOCAL_ROBOTS = {
    'epson-t3b': {
      name: 'Epson T3-B',
      axes: 4,
      maxPayload: 2.0,
      ratedSpeed: 700,
      ratedAccel: 8000,
      minSpeed: 50,
      minAccel: 500,
      derate(payloadKg) {
        const mp = this.maxPayload || 1;
        const p = Math.max(0, Number(payloadKg) || 0);
        const frac = Math.min(1, p / mp);
        const knee = 0.25;
        if (frac <= knee) return [1, 1];
        const t = (frac - knee) / (1 - knee);
        const speedScale = 1 - 0.40 * t;  // -> 0.60
        const accelScale = 1 - 0.50 * t;  // -> 0.50
        return [speedScale, accelScale];
      },
    },
  };
  
  // ----- Runtime override (from Firestore) -----
  let REMOTE_ROBOTS = null;
  
  export function setRobotsOverride(map) {
    REMOTE_ROBOTS = map && Object.keys(map).length ? map : null;
  }
  
  export function listRobots() {
    return REMOTE_ROBOTS ?? LOCAL_ROBOTS;
  }
  
  export function getRobot(robotId) {
    const src = REMOTE_ROBOTS ?? LOCAL_ROBOTS;
    const r = src[robotId];
    if (!r) throw new Error(`Unknown robot: ${robotId}`);
    return r;
  }
  